var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isBannerDisplay
    ? _c("div", { staticClass: "cookie-banner" }, [
        _c("span", { staticClass: "cookie-banner-content" }, [
          _vm._v("\n    " + _vm._s(_vm.$t("cookieBannerContent")) + "\n    "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.twmsolution.com/ebgfooter/privacy.html",
                target: "_blank",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("cookieBannerPolicyLinkText")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("cookieBannerContentLinkAfter")) + "\n  "
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "cookie-banner-btn",
            on: { click: _vm.acceptCookieHandler },
          },
          [_vm._v("\n    " + _vm._s(_vm.$t("cookieBannerButtonText")) + "\n  ")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }